import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './session.service';
import { _common } from './_common';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { NgIf } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset.password.component.html',
    standalone: true,
    imports: [FontAwesomeModule, NgIf, MatLegacyFormFieldModule, MatLegacyInputModule, ReactiveFormsModule, FormsModule, MatLegacyButtonModule]
})
export class ResetPasswordComponent implements OnInit {

  _common = _common;

  email: string = '';
  error: string = null;
  subscription: Subscription;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,

  ) {

  }

  app: string
  link = '/'
  mobile = false;
  ngOnInit() {

    this.subscription = this.route.queryParams.subscribe((params) => {

      this.app = params.app;
      this.mobile = (params.mobile == 'true');

      SessionService.fixTitle(this.app);
      this.link = `/?app=${this.app}`
    })
  }
  title() {
    return document.title;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  proceed() {


    this.http.post('/ext/signup/reset_password', {
      email: this.email,

      app: this.app
    }).subscribe((data: any) => {

      if (!data.succeed) {
        this.error = data.error;
        return;

      }

      let url = '/reset_password_sent'

      this.router.navigate([url], {
        queryParams: {
          app: this.app,
          mobile: this.mobile,
        }
      });

    }, (error) => {
      this.router.navigate(['/error']);



    });
  }

}
